// field ⇄ office cycle (AquaFlow manual): 6 stations on a circle, shared by the dialog (SVG) and the PDF (jsPDF)
export const CYC_KIND = ['field', 'hand', 'office', 'office', 'office', 'field'];
export const CYC_COL = { field: [255, 106, 19], hand: [71, 85, 105], office: [14, 116, 144] };
export const cycAng = (i) => ((-90 + i * 60) * Math.PI) / 180;
// arc points from station i to i+1 on radius R, leaving a gap of g radians at both ends
export function cycArc(i, R, g, n = 10) {
  const a = cycAng(i) + g, b = cycAng(i + 1) - g;
  return Array.from({ length: n + 1 }, (_, k) => { const t = a + ((b - a) * k) / n; return [Math.cos(t) * R, Math.sin(t) * R]; });
}

export function drawCyclePdf(d, cx, cy, R, ui, plain) {
  const r = 8, g = 0.3;
  d.setLineWidth(0.7);
  for (let i = 0; i < 6; i++) {
    const pts = cycArc(i, R, g), c = CYC_COL[CYC_KIND[i]];
    d.setDrawColor(...c);
    for (let k = 1; k < pts.length; k++) d.line(cx + pts[k - 1][0], cy + pts[k - 1][1], cx + pts[k][0], cy + pts[k][1]);
    const [x2, y2] = pts[pts.length - 1], [x1, y1] = pts[pts.length - 2], ang = Math.atan2(y2 - y1, x2 - x1), h = 2.6;
    d.setFillColor(...c);
    d.triangle(cx + x2 + Math.cos(ang) * h, cy + y2 + Math.sin(ang) * h, cx + x2 + Math.cos(ang + 2.4) * h, cy + y2 + Math.sin(ang + 2.4) * h, cx + x2 + Math.cos(ang - 2.4) * h, cy + y2 + Math.sin(ang - 2.4) * h, 'F');
  }
  for (let i = 0; i < 6; i++) {
    const a = cycAng(i), x = cx + Math.cos(a) * R, y = cy + Math.sin(a) * R, c = CYC_COL[CYC_KIND[i]];
    d.setFillColor(...c); d.circle(x, y, r, 'F');
    d.setTextColor(255); d.setFont('helvetica', 'bold'); d.setFontSize(11); d.text(String(i + 1), x, y + 1.4, { align: 'center' });
    const lx = cx + Math.cos(a) * (R + r + 3), ly = cy + Math.sin(a) * (R + r + 3) + (Math.sin(a) > 0.5 ? 3 : Math.sin(a) < -0.5 ? -1 : 1);
    const al = Math.cos(a) > 0.3 ? 'left' : Math.cos(a) < -0.3 ? 'right' : 'center';
    d.setTextColor(...c); d.setFontSize(9); d.text(d.splitTextToSize(plain(ui.cycle[i]), 42), lx, ly, { align: al });
  }
  d.setTextColor(10, 37, 64); d.setFont('helvetica', 'bold'); d.setFontSize(11); d.text(plain(ui.cycleC), cx, cy + 1.5, { align: 'center' });
  d.setFont('helvetica', 'normal'); d.setFontSize(8); d.setTextColor(110);
  [['field', ui.cycleF], ['office', ui.cycleO], ['hand', ui.cycleH]].forEach(([k, l], j) => { d.setFillColor(...CYC_COL[k]); d.circle(cx - 48 + j * 36, cy + R + 22, 1.6, 'F'); d.text(plain(l), cx - 45 + j * 36, cy + R + 23.2); });
  d.setFont('helvetica', 'normal');
}
